(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press_home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const logos = document.querySelectorAll('.press-logo');
    const quoteBox = document.getElementById('press-active-quote');
    let index = 0;
    const speed = 3000;
    let autoRotate;

    function updateHighlight(i = index) {
      logos.forEach((logo) => logo.classList.remove('active'));

      const activeLogo = logos[i];
      activeLogo.classList.add('active');

      const quote = activeLogo.getAttribute('data-quote');
      quoteBox.classList.remove('active');

      setTimeout(() => {
        quoteBox.innerHTML = quote;
        quoteBox.classList.add('active');
      }, 180);

      index = (i + 1) % logos.length;
    }

    // Auto rotation
    function startAutoRotate() {
      autoRotate = setInterval(() => {
        updateHighlight();
      }, speed);
    }

    // Stop auto rotate when user clicks
    function stopAutoRotate() {
      clearInterval(autoRotate);
    }

    // Enable click-to-highlight
    logos.forEach((logo, i) => {
      logo.addEventListener('click', function () {
        stopAutoRotate(); // stop rotation
        updateHighlight(i); // show clicked logo text
        startAutoRotate(); // optional: restart auto rotate
      });
    });

    // Initial load
    updateHighlight();
    startAutoRotate();
  });

  } catch(e) { console.error(e); }
})();
})();
